import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { ResponseDto, RecordLoginEventResponseDto } from "@mimber/schema"
import { securityEventsKeys } from "../account.utils"

export const useRecordLoginEvent = (
  options?: UseMutationOptions<
    ResponseDto<RecordLoginEventResponseDto>,
    Error,
    void
  >
): UseMutationResult<ResponseDto<RecordLoginEventResponseDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useRecordLoginEvent")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<
        ResponseDto<RecordLoginEventResponseDto>
      >("account/security-events/login-event")
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: securityEventsKeys.findAll(),
      })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
